import { useIsBannerHidden } from 'hooks/useIsBannerHidden'
import React from 'react'
import { Route, Switch } from 'react-router'
import NotificationBanner from '../Header/HeaderBanners/NotificationBanner'

const HELP_NOTIFICATION_BANNER_ROUTES: Array<string> = [
  '/:regionCode/terms-and-conditions',
  '/:regionCode/account/my-escapes',
  '/:regionCode/account/my-escapes/order/:orderId',
]

const SHOP_NOTIFICATION_BANNER_ROUTES: Array<string> = [
  '/:regionCode/shop',
  '/:regionCode/search/shop',
]

const getShopLandingBanner = (regionCode: string): App.NotificationBanner => ({
  bannerText: 'Order by 7 December to receive items before Christmas',
  linkText: 'SHOP NOW',
  linkTo: `/${regionCode.toLowerCase()}/search/shop?tags=triplepoints`,
  openInNewTab: false,
  id: 'shopLandingNotificationBanner',
  slug: 'shopLandingNotificationBanner',
  show: true,
})

function NotificationBannerRoutes() {
  const isHidden = useIsBannerHidden('notificationBanner')

  if (isHidden) {
    return null
  }

  return <Switch>
    <Route path={SHOP_NOTIFICATION_BANNER_ROUTES}>
      <NotificationBanner overrideBanner={getShopLandingBanner} />
    </Route>
    <Route path={HELP_NOTIFICATION_BANNER_ROUTES}>
      <NotificationBanner slug="help-with-banner" />
    </Route>
    <Route component={NotificationBanner} />
  </Switch>
}

export default NotificationBannerRoutes
